import { useState } from 'react'
import intl from 'react-intl-universal'
import { useOrdersContext } from '../../context'
import { OrdersFilter as Filter } from '../../../../components/orders-filter'
import { verifyIsFiltered } from 'utils/custom-functions'
import * as S from './styled'
import StorePersist from 'utils/store-persist'
import Sidebar from 'components/sidebar'
import ButtonIcon from 'components/button-icon';
import { IconFilterActive } from 'components/icons/icn-filter-active.icon';
import { IconFilterInactive } from 'components/icons/icn-filter-inactive.icon';

const OrdersFilter = () => {
  const { setFilter, filter } = useOrdersContext()
  const [openFilter, setOpenFilter] = useState(false)
  const handleClose = () => setOpenFilter(false)

  const refresh = (filters) => {
    setFilter({ ...filters, _size: filter._size })
    StorePersist.setValuesJSON("filtersOrdersMulti", filters);
    handleClose()
  }

  const getIconFilter = () => {
    if(localStorage.getItem("THEME") != 1 ){
    if(verifyIsFiltered(filter))
      return <IconFilterActive />;
    else 
      return <IconFilterInactive />;
    }else 
      return undefined;
  }

  return (
    <S.Wrapper data-testid='filter'>
      <ButtonIcon
        onClick={() => setOpenFilter(prevState => !prevState)}
        buttonType='secondary'
        buttonText={intl.get('filters.filter')}
        buttonIcon={getIconFilter()}
        style={{ width: '170px' }}
      />
      <Sidebar
        visible={openFilter}
        triggerClose={() => setOpenFilter(false)}
      >
        <Filter
          handleSearch={refresh}
          filtersDefault={filter}
        />
      </Sidebar>
    </S.Wrapper>
  )
}

export default OrdersFilter
